import { all } from "redux-saga/effects";
import startupSaga from "./startupSaga";
import libraryCardSaga from "./libraryCardSaga";
import docsSaga from "./docsSaga";

export default function* rootSaga() {
  yield all([
    startupSaga(),
    libraryCardSaga(),
    docsSaga(),
  ]);
}
